/** HTTP status codes
    @readonly
    @enum {number}
*/
export var HTTPSTATUS;
(function (HTTPSTATUS) {
    HTTPSTATUS[HTTPSTATUS["CONTINUE"] = 100] = "CONTINUE";
    HTTPSTATUS[HTTPSTATUS["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    HTTPSTATUS[HTTPSTATUS["PROCESSING"] = 102] = "PROCESSING";
    HTTPSTATUS[HTTPSTATUS["EARLY_HINTS"] = 103] = "EARLY_HINTS";
    HTTPSTATUS[HTTPSTATUS["OK"] = 200] = "OK";
    HTTPSTATUS[HTTPSTATUS["CREATED"] = 201] = "CREATED";
    HTTPSTATUS[HTTPSTATUS["ACCEPTED"] = 202] = "ACCEPTED";
    HTTPSTATUS[HTTPSTATUS["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    HTTPSTATUS[HTTPSTATUS["NO_CONTENT"] = 204] = "NO_CONTENT";
    HTTPSTATUS[HTTPSTATUS["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    HTTPSTATUS[HTTPSTATUS["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    HTTPSTATUS[HTTPSTATUS["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    HTTPSTATUS[HTTPSTATUS["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
    HTTPSTATUS[HTTPSTATUS["IM_USED"] = 226] = "IM_USED";
    HTTPSTATUS[HTTPSTATUS["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    HTTPSTATUS[HTTPSTATUS["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    HTTPSTATUS[HTTPSTATUS["FOUND"] = 302] = "FOUND";
    HTTPSTATUS[HTTPSTATUS["SEE_OTHER"] = 303] = "SEE_OTHER";
    HTTPSTATUS[HTTPSTATUS["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    HTTPSTATUS[HTTPSTATUS["USE_PROXY"] = 305] = "USE_PROXY";
    HTTPSTATUS[HTTPSTATUS["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    HTTPSTATUS[HTTPSTATUS["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    HTTPSTATUS[HTTPSTATUS["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HTTPSTATUS[HTTPSTATUS["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HTTPSTATUS[HTTPSTATUS["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    HTTPSTATUS[HTTPSTATUS["FORBIDDEN"] = 403] = "FORBIDDEN";
    HTTPSTATUS[HTTPSTATUS["NOT_FOUND"] = 404] = "NOT_FOUND";
    HTTPSTATUS[HTTPSTATUS["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    HTTPSTATUS[HTTPSTATUS["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    HTTPSTATUS[HTTPSTATUS["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    HTTPSTATUS[HTTPSTATUS["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    HTTPSTATUS[HTTPSTATUS["CONFLICT"] = 409] = "CONFLICT";
    HTTPSTATUS[HTTPSTATUS["GONE"] = 410] = "GONE";
    HTTPSTATUS[HTTPSTATUS["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    HTTPSTATUS[HTTPSTATUS["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    HTTPSTATUS[HTTPSTATUS["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    HTTPSTATUS[HTTPSTATUS["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
    HTTPSTATUS[HTTPSTATUS["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    HTTPSTATUS[HTTPSTATUS["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
    HTTPSTATUS[HTTPSTATUS["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    HTTPSTATUS[HTTPSTATUS["IM_A_TEAPOT"] = 418] = "IM_A_TEAPOT";
    HTTPSTATUS[HTTPSTATUS["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    HTTPSTATUS[HTTPSTATUS["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    HTTPSTATUS[HTTPSTATUS["LOCKED"] = 423] = "LOCKED";
    HTTPSTATUS[HTTPSTATUS["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    HTTPSTATUS[HTTPSTATUS["TOO_EARLY"] = 425] = "TOO_EARLY";
    HTTPSTATUS[HTTPSTATUS["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    HTTPSTATUS[HTTPSTATUS["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    HTTPSTATUS[HTTPSTATUS["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    HTTPSTATUS[HTTPSTATUS["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    HTTPSTATUS[HTTPSTATUS["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    HTTPSTATUS[HTTPSTATUS["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    HTTPSTATUS[HTTPSTATUS["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    HTTPSTATUS[HTTPSTATUS["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    HTTPSTATUS[HTTPSTATUS["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    HTTPSTATUS[HTTPSTATUS["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    HTTPSTATUS[HTTPSTATUS["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    HTTPSTATUS[HTTPSTATUS["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
    HTTPSTATUS[HTTPSTATUS["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    HTTPSTATUS[HTTPSTATUS["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
    HTTPSTATUS[HTTPSTATUS["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
    HTTPSTATUS[HTTPSTATUS["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(HTTPSTATUS || (HTTPSTATUS = {}));
;
